__webpack_require__.p = "https://assets-01.periodica.press/302443c-24133421397/";